import { call, put } from "redux-saga/effects";
import {
  broadcast_file_data_failure,
  broadcast_message_data_failure,
} from "../actions";

import { urls } from "../constants/constants";
import * as SagaTypes from "./saga-types";
import * as Api from "../api";

//refresh props on close
export const emptyRefreshBroadcast = () => {
  return {
    type: SagaTypes.EMPTY_BROADCAST,
  };
};

export function* emptyBroadcast() {
  yield put(broadcast_file_data_failure());
}

//refresh props on close
export const emptyMessagePatient = () => {
  return {
    type: SagaTypes.EMPTY_MESSAGE_PATIENT,
  };
};

export function* emptyPatientMessage() {
  yield put(broadcast_message_data_failure());
}

//Upload broadcast file
export function* uploadBroadCastFileNew(action) {
  try {
    const param_string = action.payload.param;
    const data = yield call(
      Api.post,
      `${urls.aspariaBackend}api/v1/broadcast/upload`,
      param_string
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(false, data.data.message);
    }
  } catch (e) {
    action.callback(false, e);
  }
}

export const uploadBroadCastFileNewAction = (param, callback) => ({
  type: SagaTypes.UPLOAD_BROADCAST_FILE_NEW,
  payload: { param },
  callback,
});
//Upload Comma separated text values
export function* uploadBroadCastCommaSeparatedValues(action) {
  try {
    const param_string = action.payload.param;
    const data = yield call(
      Api.post,
      `${urls.aspariaBackend}api/v1/broadcast/upload/values`,
      param_string
    );
    if (data?.data?.data) {
      action.callback(true, data?.data?.data);
    } else {
      action.callback(false, data?.data?.message);
    }
  } catch (e) {
    action.callback(false, e);
  }
}

export const uploadBroadCastCommaSeparatedValuesAction = (param, callback) => ({
  type: SagaTypes.UPLOAD_BROADCAST_COMMA_SEPARATED_VALUES,
  payload: { param },
  callback,
});

//Broadcast message
export function* broadCastMessage(action) {
  try {
    const param_string = action.payload.param;
    const data = yield call(
      Api.post,
      `${urls.aspariaBackend}api/v1/broadcast/message`,
      param_string
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(
        false,
        "Broadcast message cannot be delivered at the moment."
      );
    }
  } catch (e) {
    action.callback(
      false,
      "Broadcast message cannot be delivered at the moment."
    );
  }
}

export const broadCastMessageAction = (param, callback) => ({
  type: SagaTypes.BROADCAST_MESSAGE,
  payload: { param },
  callback,
});

//Broadcast review
export function* broadCastMessageReview(action) {
  try {
    const param_string = action.payload.param;
    const data = yield call(
      Api.post,
      `${urls.aspariaBackend}api/v1/broadcast/review`,
      param_string
    );

    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(false, "Review message error.");
    }
  } catch (e) {
    action.callback(false, "Review message error.");
  }
}

export const broadCastMessageReviewAction = (param, callback) => ({
  type: SagaTypes.BROADCAST_MESSAGE_REVIEW,
  payload: { param },
  callback,
});

//Broadcast patient list
export function* broadCastPatientList(action) {
  try {
    const { param = {} } = action.payload;
    const queryString = Object.keys(param)
      .reduce((r, key) => (param[key] ? [...r, `${key}=${param[key]}`] : r), [])
      .join("&");
    const data = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/broadcasts/pending/patient${
        queryString ? `?${queryString}` : ""
      }`,
      {}
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(false);
    }
  } catch (e) {
    action.callback(false);
  }
}

export const broadCastPatientListAction = (param, callback) => ({
  type: SagaTypes.BROADCAST_PATIENT_LIST,
  payload: { param },
  callback,
});

//Broadcast Employee list
export function* broadCastEmployeeList(action) {
  try {
    const { param = {} } = action.payload;
    const queryString = Object.keys(param)
      .reduce((r, key) => (param[key] ? [...r, `${key}=${param[key]}`] : r), [])
      .join("&");
    const data = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/broadcasts/pending/employee${
        queryString ? `?${queryString}` : ""
      }`,
      {}
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(false);
    }
  } catch (e) {
    action.callback(false);
  }
}

export const broadCastEmployeeListAction = (param, callback) => ({
  type: SagaTypes.BROADCAST_EMPLOYEE_LIST,
  payload: { param },
  callback,
});

//Broadcast Appointment list
export function* broadCastApiPatientList(action) {
  try {
    const { param = {} } = action.payload;
    const queryString = Object.keys(param)
      .reduce((r, key) => (param[key] ? [...r, `${key}=${param[key]}`] : r), [])
      .join("&");
    const data = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/broadcasts/pending/apiPatient${
        queryString ? `?${queryString}` : ""
      }`,
      {}
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(false);
    }
  } catch (e) {
    action.callback(false);
  }
}

export const broadCastApiPatientListAction = (param, callback) => ({
  type: SagaTypes.BROADCAST_APIPATIENT_LIST,
  payload: { param },
  callback,
});

//Remove Patient list
export function* removeBroadCastPatientList(action) {
  try {
    const { param = {} } = action.payload;
    const data = yield call(
      Api.remove,
      `${urls.aspariaBackend}api/v1/broadcast/remove/patient/${param.fileId}`,
      {}
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(false);
    }
  } catch (e) {
    action.callback(false);
  }
}

export const removeBroadCastPatientAction = (param, callback) => ({
  type: SagaTypes.DELETE_BROADCAST_PATIENT_LIST,
  payload: { param },
  callback,
});

//Remove Employee list
export function* removeBroadCastEmployeeList(action) {
  try {
    const { param = {} } = action.payload;
    const data = yield call(
      Api.remove,
      `${urls.aspariaBackend}api/v1/broadcast/remove/employee/${param.fileId}`,
      {}
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(false);
    }
  } catch (e) {
    action.callback(false);
  }
}

export const removeBroadCastEmployeeAction = (param, callback) => ({
  type: SagaTypes.DELETE_BROADCAST_EMPLOYEE_LIST,
  payload: { param },
  callback,
});

//Remove Appointment list
export function* removeBroadCastApiPatientList(action) {
  try {
    const { param = {} } = action.payload;
    const data = yield call(
      Api.remove,
      `${urls.aspariaBackend}api/v1/broadcast/remove/apiPatient/${
        param.fileId
      }`,
      {}
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(false);
    }
  } catch (e) {
    action.callback(false);
  }
}

export const removeBroadCastApiPatientAction = (param, callback) => ({
  type: SagaTypes.DELETE_BROADCAST_APIPATIENT_LIST,
  payload: { param },
  callback,
});

//Fetch providers list in Appointment tab (Nextgen and Athena only)
export function* broadCastProvidersList(action) {
  try {
    const data = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/user/getNextGenProviders`,
      {}
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(false);
    }
  } catch (e) {
    action.callback(false);
  }
}

export const broadCastProvidersListAction = (param, callback) => ({
  type: SagaTypes.BROADCAST_PROVIDERS_LIST,
  payload: { param },
  callback,
});

//Cancel appointment for nextgen
export function* cancelMessage(action) {
  try {
    const param_string = action.payload.param;
    const data = yield call(
      Api.post,
      `${urls.aspariaBackend}api/v1/patient/cancelAllAppointments`,
      param_string
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(
        false,
        "Broadcast message cannot be delivered at the moment."
      );
    }
  } catch (e) {
    action.callback(
      false,
      "Broadcast message cannot be delivered at the moment."
    );
  }
}

export const cancelMessageAction = (param, callback) => ({
  type: SagaTypes.CANCEL_MESSAGE,
  payload: { param },
  callback,
});

//Broadcast preview list
export function* broadCastPreviewList(action) {
  try {
    const { param = {} } = action.payload;
    const queryString = Object.keys(param)
      .reduce((r, key) => (param[key] ? [...r, `${key}=${param[key]}`] : r), [])
      .join("&");
    const data = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/broadcast/previewFileData${
        queryString ? `?${queryString}` : ""
      }`,
      {}
    );
    if (data && data.data && data.data.data) {
      action.callback(true, data.data.data);
    } else {
      action.callback(false);
    }
  } catch (e) {
    action.callback(false);
  }
}

export const broadCastPreviewListAction = (param, callback) => ({
  type: SagaTypes.BROADCAST_PREVIEW_LIST,
  payload: { param },
  callback,
});
